module.exports = __webpack_public_path__ + "static/media/ankh.a6e95778.svg";